export const footerContent = {
  contact: {
    eng: "CONTACT",
    esp: "CONTÁCTANOS"
  }
}